import axios from "../config/axiosInstance";
import { API } from "../config/API";

const LoadTags = (searchTerm = "") => {
  let url = API.BASE_URL + API.TAGS_LIST_ALL;
  if (searchTerm) {
    url += `?search=${encodeURIComponent(searchTerm)}`;
  }
  return axios
    .get(url)
    .then((response) => {
      const data = response.data;
      if (Array.isArray(data)) {
        const uniqueIds = new Set();
        const combinedResults: any = [];
        data.forEach((item: any) => {
          if (!uniqueIds.has(item.tag)) {
            uniqueIds.add(item.tag);
            combinedResults.push(item);
          }
        });
        return combinedResults;
      }
      return [];
    })
    .catch((error) => {
      console.warn("Failed to load tags from API:", error.message);
      return [];
    });
};

const LoadCategories = () => {
  let url = API.BASE_URL + API.CATEGORY;
  return axios.get(url).then((response) => response.data);
};

const LoadSubCategories = () => {
  let url =
    API.BASE_URL +
    API.SUBCATEGORY +
    `?populate[0]=category&pagination[limit]=100`;
  return axios.get(url).then((response) => response.data);
};

export { LoadTags, LoadCategories, LoadSubCategories };
